module.exports = __webpack_public_path__ + "static/media/macdonald.5db61ae6.png";